import ContactDataIsDisplay from './ContactDataIsDisplay'
import ContactDataIsForm from './ContactDataIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconAccountQuestion from 'components/Icons/AccountQuestion'

export default {
  id: 'contact_data_is',
  label: 'Contact data is',
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/contact-data-is',
  icon: IconAccountQuestion,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: ContactDataIsDisplay,
  form: ContactDataIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactDataIs/index.js